// extracted by mini-css-extract-plugin
module.exports = {"header":"PageLayout_header__2qnk7","main":"PageLayout_main__3GPmo","content":"PageLayout_content__UYXzc"};